<template lang="pug">
.login-error.modal-wrapper
    .modal-header
        a.close(@click="$emit('close')")
            | &times;
        h3 {{$t(title)}}

    .modal-body
        | {{$t(body)}}
</template>

<script>
export default {
    name: 'LoginError',

    props: {
        title: {
            type: String,
            required: true
        },
        body: {
            type: String,
            required: true
        }
    }
}
</script>
